import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MainService } from 'src/app/services/main.service';
import { SurveysService } from 'src/app/services/surveys.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-ticket-info',
  templateUrl: './ticket-info.component.html',
  styleUrls: ['./ticket-info.component.scss']
})
export class TicketInfoComponent implements OnInit {

  materialList: {id: number, nombre: string, cantidad: number}[] = [];
  sucursal: string = '';
  zona: string = '';
  consecutivo: string = '';
  id_ext: string = '';
  alias_id_ext: string = '';
  responsable: string = '';
  puesto: string = '';
  comentarios: string = '';
  fecha_respuesta: string = '';
  alertsList : any = [];

  displayedColumns: string[] = ['id', 'nombre', 'cantidad','status'];
  dataSource: any = [];

  currentIndex = 0;
  
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  dataImages: any = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    private surveyS : SurveysService,
    private main : MainService,
  ) { }

  ngOnInit(): void {

    this.sucursal = this.data.sucursal;
    this.zona = this.data.zona;
    this.consecutivo = this.data.consecutivo;
    this.id_ext = this.data.id_ext;
    this.alias_id_ext = environment.alias.id_ext;
    this.responsable = this.data.nombre_encuestado;
    this.puesto = this.data.puesto_encuestado;
    this.comentarios = this.data.comentarios;
    this.fecha_respuesta = this.data.fecha_form;

    this.data.materiales_comp.map( (item: any) => {
      const mat = this.data.mats_camp.find( (e:any) => e.id_m == item.id );
      if(mat){
        item.nombre = mat.nombre;
      }
    })

    this.getAlertas();
    this.getImages();
    this.getDataSurvey();

  }

  getAlertas() {

        this.main.ShowLoading();

    if (this.data.id_enc_resp != null) {

      this.surveyS.getAlerts(this.data.id_compania, this.data.id_campana, this.data.id, "claw").subscribe((results: any) => {
        if (results.message == "Success") {
          this.alertsList = results.data.tickets;
          const separator = ' | ';

          this.alertsList.map((item: any) => {
            const partes = item.comentario.split(separator);
            item.name_tipo = partes[0];
          })

        }
      })

    }

  }


  getDataSurvey() {
    this.surveyS.getSurveyView(this.data.id_campana_nest, this.data.id_sucursal, this.data.id).subscribe((x: any) => {
      if (x.message == "Success") {
        this.materialList = x.data.surveyData.materiales;
        this.dataSource = new MatTableDataSource(this.materialList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.main.HideLoading();
      }
    });
  }

  getImages() {
    if (this.data.id_enc_resp != null) {
      this.surveyS.getImagesAnswer(this.data.id_enc_resp).subscribe(
        (result: any) => {
          this.dataImages = result.data;
        },
        (err: any) => {
          console.log(err);
          Swal.fire({
            icon: 'error',
            title: 'Error al obtener imágenes',
            text: 'Ocurrió un error al obtnener las imágenes, por favor vuelve a intentarlo.'
          });
        }
      );
    }
  }


  get conteoTipos(): Record<string, number> {
    const counts: Record<string, number> = {
      'Material dañado': 0,
      'Kit incompleto': 0,
      'Faltante': 0,
      'Otro': 0
    };

    this.alertsList.forEach((a: any) => {
      if (counts[a.name_tipo] !== undefined) {
        counts[a.name_tipo]++;
      } else {
        counts['Otro']++;
      }
    });

    return counts;
  }

  get totalAlertas(): number {
    return Object.values(this.conteoTipos).reduce((a, b) => a + b, 0);
  }

  get tiposConValor() {
    return Object.keys(this.conteoTipos).filter(tipo => this.conteoTipos[tipo] > 0);
  }

  esPrimero(tipo: string): boolean {
    return this.tiposConValor[0] === tipo;
  }

  esUltimo(tipo: string): boolean {
    return this.tiposConValor[this.tiposConValor.length - 1] === tipo;
  }

  
  siguiente() {
    this.currentIndex = (this.currentIndex + 1) % this.dataImages.length;
  }

  anterior() {
    this.currentIndex =
      (this.currentIndex - 1 + this.dataImages.length) % this.dataImages.length;
  }

  irA(index: number) {
    this.currentIndex = index;
  }

  async descargarZIP() {

     this.surveyS.getZipImages(this.data.id_enc_resp).subscribe(
        (response: Blob) => {
          
            const blob = new Blob([response], { type: 'application/zip' });
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = this.sucursal + '.zip';
            a.click();

            window.URL.revokeObjectURL(url);
          
        },
        (error: any) => {
          console.error('Error descargando el archivo:', error);
        }
      );

  }

  get totalMateriales(): number {
    return this.materialList.reduce((total, item) => total + item.cantidad, 0);
  }

}
